import script from "./KeywordPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./KeywordPopover.vue?vue&type=script&setup=true&lang=ts"

import "./KeywordPopover.vue?vue&type=style&index=0&id=5c52d540&lang=css"
import "./KeywordPopover.vue?vue&type=style&index=1&id=5c52d540&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c52d540"]])

export default __exports__